import { api } from '@/lib/api';

export type DeleteFeature = 'leave' | 'penalty';
export type DeleteMode = 'disabled' | 'role_wise' | 'person_wise';

export interface DeleteAccessPersonGrant {
  id: string;
  user_id: string;
  first_name: string | null;
  last_name: string | null;
  employee_code: string | null;
}

export interface DeleteAccessConfig {
  mode: DeleteMode;
  allowed_roles: string[];
  person_grants: DeleteAccessPersonGrant[];
}

export const deleteAccessService = {
  async getConfig(feature: DeleteFeature): Promise<DeleteAccessConfig> {
    const res = await api.get<{ data: DeleteAccessConfig }>(`/delete-access/${feature}/config`);
    return res.data.data;
  },

  async updateMode(feature: DeleteFeature, mode: DeleteMode): Promise<void> {
    await api.patch(`/delete-access/${feature}/mode`, { mode });
  },

  async addRoleGrant(feature: DeleteFeature, roleCode: string): Promise<void> {
    await api.post(`/delete-access/${feature}/roles/${roleCode}`);
  },

  async removeRoleGrant(feature: DeleteFeature, roleCode: string): Promise<void> {
    await api.delete(`/delete-access/${feature}/roles/${roleCode}`);
  },

  async addPersonGrant(feature: DeleteFeature, userId: string): Promise<void> {
    await api.post(`/delete-access/${feature}/persons/${userId}`);
  },

  async removePersonGrant(feature: DeleteFeature, grantId: string): Promise<void> {
    await api.delete(`/delete-access/${feature}/persons/${grantId}`);
  },

  async getMyPermission(feature: DeleteFeature): Promise<{ can_delete: boolean }> {
    const res = await api.get<{ data: { can_delete: boolean } }>(`/delete-access/${feature}/my-permission`);
    return res.data.data;
  },
};
